import React from 'react';
import PropTypes from 'prop-types';
import {observer, inject} from 'mobx-react';
import {locationShape, routerShape, withRouter} from 'react-router';

import {withI18n} from 'spa/Components/Context';
import {isProduction} from 'spa/lib/environment';

import Loading from 'spa/images/icons/loading-transparent.svg';

const ERROR_3DS_FAILURE_REDIRECT = 'ERROR_3DS_FAILURE_REDIRECT';

@withRouter
@inject(({
  store: {
    tracker,
  },
}) => (
  {
    tracker,
  }
))
@observer
@withI18n
class CheckoutComRedirect extends React.Component {
  static propTypes = {
    location: locationShape.isRequired,
    router: routerShape.isRequired,
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }),
  };

  UNSAFE_componentWillMount() {
    const {i18n} = this.context;
    const {tracker} = this.props;

    const {pathname, query} = this.props.location;

    this.messageData = {
      closePopup: true,
      fromCheckout3DSRedirect: true,
    };

    const {charge_id: chargeId = null} = query;

    if (pathname === '/checkout-gateway-3ds-success-redirect') {
      this.messageData.paymentToken = query['cko-payment-token'];
      this.messageData.query = query;

      tracker.track('3DS Check - success redirect', {
        charge_id: chargeId,
        category: '3DS Check',
      });
    } else {
      // return error if it's /checkout-gateway-3ds-failure-redirect or any other unknown pathname
      this.messageData.error = true;
      this.messageData.errorCode = ERROR_3DS_FAILURE_REDIRECT;
      this.messageData.chargeId = chargeId;

      tracker.track('3DS Check - error redirect', {
        charge_id: chargeId,
        category: '3DS Check',
      });
    }

    if (typeof window !== 'undefined') {
      window.parent.postMessage(this.messageData, isProduction ? i18n.baseDomain : '*');
    }
  }

  render() {
    const {i18n} = this.context;

    return (
      <div className="checkout-com-redirect v-container full-height">
        <img src={Loading} alt="" />
        <p className="checkout-com-redirect__paragraph">
          {i18n._x('Redirecting to checkout...', 'Payment 3DS check redirect')}
        </p>
      </div>
    );
  }
}

export default CheckoutComRedirect;



// WEBPACK FOOTER //
// ./spa/Pages/Payments/CheckoutComRedirect.jsx